import React from 'react';
import { AiButton, StreamPreview } from '../shared';
import { Input } from '../../../../components/ui/input';

export const validate = (wf) => {
  const claims = wf.data?.facts?.claims || [];
  const pendingHigh = claims.filter((c) => c.risk === 'high' && !c.verified && !c.removed);
  if (pendingHigh.length) return `${pendingHigh.length} high-risk claim(s) still need to be verified or removed.`;
  return null;
};

const RISK = { high: 'bg-red-50 text-red-700', medium: 'bg-amber-50 text-amber-700', low: 'bg-emerald-50 text-emerald-700' };

const StepFacts = ({ wf, setData, runAi, ai }) => {
  const d = wf.data?.facts || {};
  const claims = d.claims || [];
  const running = ai.running && ai.action === 'facts';

  const check = async () => {
    const res = await runAi('facts');
    if (res) setData('facts', { ai: res, claims: (res.claims || []).map((c) => ({ ...c, verified: false, removed: false, note: '' })) });
  };
  const patch = (i, p) => setData('facts', { claims: claims.map((c, j) => (j === i ? { ...c, ...p } : c)) });
  const verified = claims.filter((c) => c.verified).length;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 flex-wrap">
        <AiButton onClick={check} running={running} label={claims.length ? 'Re-scan claims with AI' : 'Scan draft for claims with AI'} runningLabel="Scanning…" testId="facts-generate-btn" />
        {claims.length > 0 && <span className="text-xs text-ink-3" data-testid="facts-progress">{verified} of {claims.length} verified</span>}
      </div>
      {running && <StreamPreview text={ai.text} label="Extracting verifiable claims…" />}
      {claims.length > 0 && !running && (
        <div className="space-y-2" data-testid="facts-claims">
          {claims.map((c, i) => (
            <div key={i} className={`p-4 rounded-2xl border ${c.removed ? 'opacity-50 border-dashed' : c.verified ? 'border-emerald-200 bg-emerald-50/30' : 'border-[var(--line-2)]'}`}>
              <div className="flex items-start gap-3">
                <input type="checkbox" checked={!!c.verified} disabled={c.removed} onChange={(e) => patch(i, { verified: e.target.checked })} className="mt-1" data-testid={`facts-verify-${i}`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider ${RISK[c.risk] || RISK.low}`}>{c.risk}</span>
                    <span className="text-sm font-medium text-ink">{c.claim}</span>
                  </div>
                  <div className="text-[12px] text-ink-3 mt-1">{c.why}</div>
                  {c.suggestion && <div className="text-[12px] text-ink-2 mt-1">Suggestion: {c.suggestion}</div>}
                  <Input value={c.note || ''} onChange={(e) => patch(i, { note: e.target.value })} placeholder="Source / verification note" className="mt-2 rounded-lg border-[var(--line-2)] text-xs h-8" />
                </div>
                <button type="button" onClick={() => patch(i, { removed: !c.removed, verified: false })} className="text-[11px] text-ink-3 hover:text-ink whitespace-nowrap" data-testid={`facts-remove-${i}`}>
                  {c.removed ? 'Restore' : 'Removed from draft'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="text-xs text-ink-3">Mark a claim “Removed from draft” if you delete it during Human Editing. All high-risk claims must be verified or removed to continue.</div>
    </div>
  );
};

export default StepFacts;
